class UA {
  static isYuanTiku () {
    return /YuanTiKu/i.test(navigator.userAgent)
  }

  static isYuanFuDao () {
    return /YuanFuDao/i.test(navigator.userAgent)
  }

  static isYuanSouTi () {
    return /YuanSouTi/i.test(navigator.userAgent)
  }

  static getAppId () {
    if (UA.isYuanTiku()) {
      return 101
    } else if (UA.isYuanSouTi()) {
      return 201
    } else {
      return 0
    }
  }
}

export default UA



// WEBPACK FOOTER //
// ./src/utils/ua.js